<template>
    <a class="btn btn-secondary mb-2" :href="route_back">Вернуться</a>
    <div>
        <div v-for="(location, location_index) in devices">
            <span class="fs-3">
                Адрес "{{location.location.street}}":
            </span>
            <div v-for="(device, device_index) in location.devices" class="card" style="width: 18rem;">
                <div class="card-body">
                    <h5 class="card-title">{{device.device_key}}</h5>
                    <a v-if="device.active" href="" class="btn btn-danger" v-on:click="deleteDevice(location_index, device_index)">Удалить</a>
                    <a v-else href="" class="btn btn-success" v-on:click="addDevice(location_index, device_index)">Добавить</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Group from "../../../../models/Group";

export default {
    name: "GroupDeviceComponent",
    props: {
        route_back: String,
        route_get: String,
        route_device_add: String,
        route_device_del: String,
        item_id: {
            type: Number,
            default: 0
        }
    },
    data: function () {
        return {
            group: new Group({
                route_get: this.route_get,
                route_device_add: this.route_device_add,
                route_device_del: this.route_device_del,
            }),
            item: {},
            devices: []
        }
    },
    methods: {
        getObject: async function () {
            let response = await this.group.get(this.item_id);
            this.item = response.group;
            this.devices = response.devices;
        },
        addDevice: async function (location_index, device_index) {
            event.preventDefault();
            let result = await this.group.addDevice(this.item_id, this.devices[location_index].devices[device_index].id);
            if (result) {
                this.devices[location_index].devices[device_index].active = true;
            } else {
                console.log('error: device_add');
            }
        },
        deleteDevice: async function (location_index, device_index) {
            event.preventDefault();
            let result = await this.group.delDevice(this.item_id, this.devices[location_index].devices[device_index].id);
            if (result) {
                this.devices[location_index].devices[device_index].active = false;
            } else {
                console.log('error: device_del');
            }
        }
    },
    mounted() {
        this.getObject();
    }
}
</script>

<style scoped>

</style>
